import React from 'react';
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import {InputSwitch} from 'primereact/inputswitch';

export default class ModalEditarWorkflow extends React.Component {

    constructor(props) {
        super(props);
    }


    render(){
        return(
            <Dialog header="Editar Workflow do Site"
                    position="top"
                    visible={this.props.show}
                    style={{width: '50vw'}}
                    modal onHide={this.props.onHide}>
                <div className="container-fluid">

                    {this.props.current_edit && (
                        <React.Fragment>


                            <div className="form-group row">
                                <div className="col-12">
                                    <InputSwitch
                                        checked={this.props.current_edit.use_workflow}
                                        onChange={(e) => this.props.handleChange("use_workflow", e.value)}
                                    />
                                    <label htmlFor="workflowCriado">Habilitado</label> <br />
                                    <small>Ao desabilitar a coleta para o site, caso o workflow já tenha sido criado, ele será removido do serviço da Kadoa.</small>
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-12">
                                    <label htmlFor="frequencia">Frequência</label>
                                    <Dropdown
                                        style={{width: '100%'}}
                                        id="frequencia"
                                        value={this.props.current_edit.workflow_frequency}
                                        options={this.props.frequencias}
                                        onChange={(e) => this.props.handleChange("workflow_frequency", e.value)}
                                        placeholder="Selecione a frequência"
                                        appendTo={document.body}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-12" style={{marginTop: '25px'}}>
                                    <button className="btn btn-sm btn-block btn-success" onClick={this.props.handleSave}>
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </Dialog>

        );
    }
}
